import { createContext } from 'react'

export const DatastoreContext = createContext<{
  data: Record<string, { id: string; name: string; meta: Record<string, string> }[]>
  isLoading: boolean
  isInitialLoading: boolean
}>({
  data: {},
  isLoading: true,
  isInitialLoading: true,
})
